module.exports = "/assets/0b16b60c40162b40df05d1398fffb9d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/5K.png
// module id = 1062
// module chunks = 0